<template>
  <v-container fluid>
    <v-row class="flex-column" justify="center" align="center" no-gutters>
      <v-col class="text-center mb-2">
        <span class="overline">{{ label }}</span>
      </v-col>
      <v-col>
        <v-btn block small @click="incrementVital">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-text-field
          :label="label"
          v-model.number="innerValue"
          :hint="hintText"
          persistent-hint
          single-line
        >
          <v-icon slot="append" :color="iconColorString.color">
            {{ iconColorString.icon }}
          </v-icon>
        </v-text-field>
      </v-col>
      <v-col>
        <v-btn block small @click="decrementVital">
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'VitalField',
    props: ['label', 'vital'],
    components: {},
    computed: {
      innerValue: {
        get() {
          return this.$store.state.character.vitals[this.vital].current;
        },
        set(val) {
          this.$store.dispatch('character/setVital', {vital: this.vital, value: val});
        },
      },
      iconColorString() {
        switch (this.vital) {
          case 'health':
            return {
              icon: 'mdi-bottle-tonic-plus-outline',
              color: 'green',
            };
          case 'spirit':
            return {
              icon: 'mdi-ghost',
              color: 'purple',
            };
          case 'supply':
            return {
              icon: 'mdi-bag-personal-outline',
              color: 'brown',
            };
          default:
            return {
              icon: 'mdi-home',
              color: 'blue',
            };
        }
      },

      hintText() {
        return '';
        //return `Max: ${this.$store.getters[`${this.value}Max`]}`;
      },
    },

    methods: {
      incrementVital() {
        this.$store.dispatch('character/setVital', {
          vital: this.vital,
          value: this.innerValue + 1,
        });
      },
      decrementVital() {
        this.$store.dispatch('character/setVital', {
          vital: this.vital,
          value: this.innerValue - 1,
        });
      },
    },
  };
</script>
